import styled from "styled-components";
import { Button, colors } from "@streeteasy/design-system";

const { BRAND, WHITE } = colors;

export const LinkButton = styled(Button).attrs({})`
  background: none;
  border: none;
  color: ${BRAND};
  font-size: inherit;
  font-weight: normal;
  height: 100%;
  min-width: auto;
  padding: 0;
  text-decoration: underline;
  text-transform: none;

  &:hover,
  &:active {
    background-color: ${WHITE};
  }

  @media (max-width: 979px) {
    line-height: 22px;
  }
`;
